import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { routesConfiguration } from "../const/RoutesConfiguration";
import { t2sWithCharMap } from "../utils";
import { Language } from "../components";

export const usePageMeta = (lang: Language) => {
  const location = useLocation();

  function getSingleText(singleText: string, singleCNText: string): string {
    switch (lang) {
      case Language.EN:
        return singleText;
      case Language.TC:
        return singleCNText;
      case Language.SC:
        return t2sWithCharMap(singleCNText);
      default:
        return singleText;
    }
  }
  const DEFAULT_TITLE = getSingleText("HKCTC", "香港檢測和認證局");

  const DEFAULT_DESC = getSingleText(
    "The Hong Kong Council for Testing and Certification",
    "香港檢測和認證局"
  );

  useEffect(() => {
    const currentRoute = routesConfiguration.find(
      (route) => route.path === location.pathname
    );

    let finalTitle =
      getSingleText(currentRoute?.title ?? "", currentRoute?.titleCN ?? "") ||
      DEFAULT_TITLE;

    let finalDescription =
      getSingleText(
        currentRoute?.description ?? "",
        currentRoute?.descriptionCN ?? ""
      ) || DEFAULT_DESC;

    // duplicated path（ /hkctc & /）
    if (
      location.pathname === "/" + lang + "/hkctc" ||
      location.pathname === "/" + lang
    ) {
      finalTitle = getSingleText("Homepage", "主頁");
      finalDescription = getSingleText(
        "Welcome to HKCTC",
        "歡迎來到香港檢測和認證局"
      );
    }

    // HKCTC - XXX /香港檢測和認證局 - XXX

    document.title = `${DEFAULT_TITLE} | ${finalTitle}`;

    if (location.pathname === "/*") {
      document.title = `${DEFAULT_TITLE} | Not Found`;
      finalDescription = getSingleText(
        "Page not found on the HKCTC website.",
        "找不到頁面。"
      );
    }

    // 設置 <meta name="description">
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", finalDescription);
    } else {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.content = finalDescription;
      document.head.appendChild(newMeta);
    }
  }, [location.pathname, lang]);
};
